export default "__VITE_ASSET__tUjVfKDN__"